module.exports = __webpack_public_path__ + "img/card-referencias.2f14fcbc.svg";